export const loyaltyLevels = {
  1: 'Orange',
  2: 'Black',
  3: 'JetBlack',
};
